import { createRouter, createWebHistory } from 'vue-router';
import store from '@/store';
// routes
import AuthRoutes from './auth';
import PrivateRoutes from './private';
// Pages
import LogoutPage from '@/pages/base/LogoutPage/LogoutPage.vue';
import InviteRequestPage from '@/pages/base/InviteRequestPage/InviteRequestPage.vue';

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  scrollBehavior(to) {
    if (to.hash) return { el: to.hash, behavior: 'smooth', top: 60 };
    return { top: 0 };
  },
  routes: [
    {
      path: '/:pathMatch(.*)*',
      component: () => import('@/pages/guest/NotFoundPage/NotFoundPage.vue')
    },
    {
      path: '/logout',
      name: 'Logout',
      component: LogoutPage
    },
    {
      path: '/request-for-proposal/:id',
      component: InviteRequestPage
    },
    PrivateRoutes,
    AuthRoutes
  ]
});

router.beforeEach((to, _, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (store.getters['user/isAuth']) {
      next();
      return;
    }
    next('/auth/login');
  } else {
    next();
  }
});

router.beforeEach((to, _, next) => {
  if (to.matched.some((record) => record.meta.guest)) {
    if (store.getters['user/isAuth']) {
      next('/');
      return;
    }
    next();
  } else {
    next();
  }
});
export default router;
